// extracted by mini-css-extract-plugin
export default {"loader__wrapper":"loading_loader__wrapper__awH5s","loader__container":"loading_loader__container__8qcc9","nospinago":"loading_nospinago__6+qFG","spinago":"loading_spinago__vRGx1"};